import lazyWithPreload from "./components/common/lazyWithPreload";

// The pages a user lands on straight after signing in. They load on demand like every other page, but the login
// page starts fetching them while the sign-in is being checked, so the dashboard opens without a loading spinner.
export const Header = lazyWithPreload(() => import("./components/admin/home/Header"));
export const NewDashboards = lazyWithPreload(() => import("./components/admin/dashboard/NewDashboards"));

export const preloadPagesAfterLogin = () => Promise.all([Header.preload(), NewDashboards.preload()]);
